import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';

// 查询品牌列表(有权限)
export const queryBrands: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setBrands', { ...state.list, loading: true });
    // const { list, pageNum, pageSize, total } = await $http.post('/brand/page', payload);
    const { list, pageNum, pageSize, total } = await $http.post('/v1/baseinfo/brand/pagelist', payload);
    commit('setBrands', { data: list, pageNum, pageSize, total });
  } catch (e) {
    commit('setBrands', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询品牌列表(无权限)
export const queryDataBrands: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDataBrands', { ...state.dataBrands, loading: true });
    // const { list, pageNum, pageSize, total } = await $http.post('/brand/page', payload);
    const { list, pageNum, pageSize, total } = await $http.post('/v1/data/baseinfo/brand/pagelist', payload);
    commit('setDataBrands', { data: list, pageNum, pageSize, total });
  } catch (e) {
    commit('setDataBrands', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询品牌详情
export const queryBrandDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setBrandDetail', { data: null, loading: true });
    // const res = await $http.get(`/brand/detail/${payload}`);
    const res = await $http.get(`/v1/baseinfo/brand/${payload}/detailinfo`);
    commit('setBrandDetail', { data: res });
  } catch (e) {
    commit('setBrandDetail', { data: null });
  }
};

// 添加品牌
export const addBrand: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/brand/add', payload);
    await $http.post('/v1/baseinfo/brand/add', payload);
  } finally {
    commit('setLoading', false);
  }
};

// 编辑品牌
export const editBrand: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/brand/modify', payload);
    await $http.post('/v1/baseinfo/brand/modify', payload);
  } finally {
    commit('setLoading', false);
  }
};

// 删除品牌
export const deleteBrand: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/brand/delete', payload);
    await $http.post('/v1/baseinfo/brand/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 根据品牌id查询其所有下游品牌(包含已关联和未关联的下游品牌)
export const queryAllSubBrands: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setAllSubBrands', { ...state.allSubBrands, loading: true });
    // const { list, pageNum, pageSize, total } = await $http.post('/data/brand/unintegrated/search', payload);
    const { list, pageNum, pageSize, total } = await $http.post('/v1/baseinfo/brand/searchsub', payload);
    commit('setAllSubBrands', { data: list, pageNum, pageSize, total });
  } catch (e) {
    commit('setAllSubBrands', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询已关联的品牌列表(下游品牌)
export const querySubBrands: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setSubBrands', { ...state.subBrands, loading: true });
    // const { list, pageNum, pageSize, total } = await $http.post('data/subbrand/search', payload);
    const { list, pageNum, pageSize, total } = await $http.post('/v1/baseinfo/brand/subbrands', payload);
    commit('setSubBrands', { data: list, pageNum, pageSize, total });
  } catch (e) {
    commit('setSubBrands', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 批量新增下游品牌
export const addSubBrand: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    // await $http.post('brand/subbrand/batch/add', payload);
    await $http.post('/v1/baseinfo/brand/addsubbrand', payload);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 批量删除下游品牌
export const deleteSubBrand: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('brand/subbrand/batch/delete', payload);
    await $http.post('/v1/baseinfo/brand/deletesubbrand', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 查询所有非平台组织信息(包含已授权和未授权)
export const queryAllAuthOrgs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setAllAuthOrgs', { ...state.allAuthOrgs, loading: true });
    // const { list, pageNum, pageSize, total } = await $http.post('/authorization/org/list', payload);
    const { list, pageNum, pageSize, total } = await $http.post('/v1/data/baseinfo/brand/authpagelist', payload);
    commit('setAllAuthOrgs', { data: list, pageNum, pageSize, total });
  } catch (e) {
    commit('setAllAuthOrgs', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询某个品牌已授权的组织列表
export const queryAuthedOrgs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setAuthedOrgs', { ...state.authedOrgs, loading: true });
    // const { list, pageNum, pageSize, total } = await $http.post('/authorization/brand/detail', payload);
    const { list, pageNum, pageSize, total } = await $http.post('/v1/baseinfo/brand/authorg', payload);
    commit('setAuthedOrgs', { data: list, pageNum, pageSize, total });
  } catch (e) {
    commit('setAuthedOrgs', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 为某个品牌添加授权组织
export const addAuthOrg: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    // await $http.post('/baseinfo/organizations/brand/authorization', payload);
    await $http.post('/v1/baseinfo/brand/addauthorg', payload);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 批量取消授权
export const deleteAuthOrg: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/authorization/ref/delete', payload);
    await $http.post('/v1/baseinfo/brand/deleteauthorg', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 修改品牌拥有者
export const changeOwner: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/brand/auth/modify', payload);
    await $http.post('/v1/baseinfo/brand/modifyowner', payload);
  } finally {
    commit('setLoading', false);
  }
};
